/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'ecosystem';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/ecosystem/v1/reviews
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ReviewsResource+type:symbol+createReview&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Advanced-post-%2Fecosystem%2Fv1%2Freviews'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fecosystem%2Fv1%2Freviews?showRequestDetails=true&body=%7B%22reviewType%22:%22string%22,%22entityId%22:0,%22entityVersion%22:0,%22entityPortal%22:0,%22offeringId%22:0,%22profileId%22:0,%22employees%22:%22string%22,%22companyName%22:%22string%22,%22showAvatar%22:false,%22ratings%22:0,%22content%22:%7B%22title%22:%22string%22,%22text%22:%22string%22,%22pros%22:%22string%22,%22cons%22:%22string%22,%22customizable%22:%22string%22,%22catalogServices%22:%5B0%5D,%22privateFeedback%22:%22string%22,%22for%22:%22string%22%7D,%22answers%22:%22string%22,%22tags%22:0,%22marketplaceIndustry%22:%22string%22%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const createRatingReviewRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/reviews'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/ecosystem/v1/reviews/tag/values
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ReviewsResource+type:symbol+getReviewGroupValues&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Basic-get-%2Fecosystem%2Fv1%2Freviews%2Ftag%2Fvalues'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fecosystem%2Fv1%2Freviews%2Ftag%2Fvalues?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getReviewGroupValuesRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/reviews/tag/values'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/ecosystem/v1/reviews/stats
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ReviewsResource+type:symbol+getStats&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Advanced-post-%2Fecosystem%2Fv1%2Freviews%2Fstats'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fecosystem%2Fv1%2Freviews%2Fstats?showRequestDetails=true&body=%7B%22entityId%22:0,%22reviewType%22:%22string%22,%22offeringId%22:0,%22profileId%22:0%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getStatsRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/reviews/stats'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/ecosystem/v1/reviews/search
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ReviewsResource+type:symbol+searchReviews&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Search-post-%2Fecosystem%2Fv1%2Freviews%2Fsearch'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fecosystem%2Fv1%2Freviews%2Fsearch?showRequestDetails=true&body=%7B%22search%22:%22string%22,%22sortFields%22:%5B%22string%22%5D,%22entityId%22:0,%22profileId%22:0,%22offeringId%22:0,%22reviewTypes%22:%5B%22string%22%5D,%22overallRating%22:0,%22employeeSizes%22:%7B%22clause%22:%22string%22,%22values%22:%5B%22string%22%5D%7D,%22marketplaceIndustries%22:%7B%22clause%22:%22string%22,%22values%22:%5B%22string%22%5D%7D,%22catalogServices%22:%7B%22clause%22:%22string%22,%22values%22:%5B0%5D%7D,%22reviewerPortalId%22:0,%22reviewerUserId%22:0,%22language%22:%22string%22,%22limit%22:0,%22offset%22:0%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const searchReviewsRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/reviews/search'])
});